import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../api/api";
import { ReactComponent as CloseIcon } from "../../../assets/icons/modal/close.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { IBrand } from "../../../types/brands.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import EditBrandForm from "../forms/EditBrandForm/EditBrandForm";
import ViewBrandForm from "../forms/EditBrandForm/ViewBrandForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  brand: IBrand;
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
}

const EditBrandModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(!props.isInfo);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressDelete = async () => {
    try {
      const response = await authApiService.deleteBrand(props.brand.id);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err: any) {
      console.error(err.message);
      if (
        err.response.data.message ===
        "Cannot delete provider with associated resources."
      ) {
        toast.error(
          "Не можливо видалити бренд, якщо є повʼязаний з ним ресурс."
        );
      }
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Підтвердіть видалення бренду"
              subTitle="Ви дійсно хочете видалити цей бренд? Цю дію неможливо скасувати."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => {
                setIsDelete(false);
              }}
              applyTitle="Видалити"
              backTitle="Назад"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Редагувати бренд"
              subTitle='Редагуйте інформацію. Внесіть необхідні зміни та натисніть "Зберегти".'
            ></ModalTitle>
            <EditBrandForm
              onApply={onPressApply}
              onClose={() => setIsDelete(true)}
              brand={props.brand}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.upSide}>
                {props.brand.imageUrl ? (
                  <img
                    src={props.brand.imageUrl}
                    alt="Avatar"
                    className={styles.avatar}
                  />
                ) : (
                  <div />
                )}
                <button className={styles.upSideButton} onClick={props.onClose}>
                  <CloseIcon />
                </button>
              </div>
              <div className={styles.nameContainer}>
                <span className={styles.name}>{props.brand.name}</span>
              </div>
            </div>
            <ViewBrandForm
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              brand={props.brand}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditBrandModal;
